import { Capacitor } from '@capacitor/core';

/**
 * Check if app is running in native Capacitor context (iOS or Android)
 */
export const isNative = (): boolean => {
    return Capacitor.isNativePlatform();
};

/**
 * Get current platform
 * @returns 'ios' | 'android' | 'web'
 */
export const getPlatform = (): 'ios' | 'android' | 'web' => {
    return Capacitor.getPlatform() as 'ios' | 'android' | 'web';
};

/**
 * Check if running on iOS
 */
export const isIOS = (): boolean => {
    return getPlatform() === 'ios';
};

/**
 * Check if running on Android
 */
export const isAndroid = (): boolean => {
    return getPlatform() === 'android';
};

/**
 * Check if running on web (not native)
 */
export const isWeb = (): boolean => {
    return !isNative();
};
